import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";
import * as resources from "../constants/resources";
import * as rccHelper from "../helpers/rccResponseHelper";
import * as messageHelper from "../helpers/messageHelper";
import * as modelHelper from "../helpers/modelHelper";
import * as componentTypes from "../constants/componentTypes";

export const processWebsocketEventResponse = (response, state) => {
    switch (response.event) {
        case methods.MACHINE_EVENT_IDLE:
            return [
                {
                    type: actionTypes.MACHINE_SET_BUSY,
                    payload: {
                        isBusy: false
                    }
                }
            ];
        case methods.MACHINE_EVENT_BUSY:
            return [
                {
                    type: actionTypes.MACHINE_SET_BUSY,
                    payload: {
                        isBusy: true
                    }
                }
            ];
        case methods.MACHINE_EVENT_DIALOG_SHOW:
            return rccHelper.processDialogResponse(methods.MACHINE_EVENT_DIALOG_SHOW, response.data, state);
        case methods.MACHINE_EVENT_DIALOG_HIDE:
            return [
                {
                    type: actionTypes.CANCEL_RCC_DIALOG
                }
            ];
        case methods.MACHINE_EVENT_PROGRESS_UPDATED:
            if (response.data.task === undefined || response.data.task === null) {
                return [];
            }

            if (
                response.data.percentage === undefined ||
                response.data.percentage === null ||
                response.data.timeLeft === undefined ||
                response.data.timeLeft === null
            ) {
                return [
                    {
                        type: actionTypes.SAVE_RCC_DIALOG_PROGRESS,
                        payload: {
                            percentage: 0,
                            timeLeft: 0,
                            progressItems: modelHelper.mapDialogProgressItems(
                                response.data,
                                state.global.colorantList,
                                state.rcc.canisterList,
                                state.rcc.channelList
                            )
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_DIALOG_PROGRESS,
                    payload: {
                        percentage: response.data.percentage,
                        timeLeft: response.data.timeLeft,
                        progressItems: modelHelper.mapDialogProgressItems(
                            response.data,
                            state.global.colorantList,
                            state.rcc.canisterList,
                            state.rcc.channelList
                        )
                    }
                }
            ];
        case methods.MACHINE_EVENT_PROGRESS_CLEARED:
            return [
                {
                    type: actionTypes.SAVE_RCC_DIALOG_PROGRESS,
                    payload: {
                        percentage: 0,
                        timeLeft: 0,
                        progressItems: []
                    }
                }
            ];
        case methods.MACHINE_EVENT_ERRORS_UPDATED:
            return [
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_ERRORS
                    },
                    method: handlers.MACHINE_GET_ERRORS,
                    tabId: 0,
                    safe: false
                }
            ];
        case methods.MACHINE_EVENT_DISPENSE_CANISTER_STARTED:
            if (!rccHelper.isDispenseCanisterStartedEventValid(response)) {
                return [messageHelper.getRccInvalidFormatMessage(response)];
            }

            let canisterActions = [
                {
                    type: actionTypes.UPDATE_DISPENSING_INFO,
                    payload: {
                        tabId: response.data.meta.tabId,
                        numCanDone: response.data.numDone === undefined ? null : response.data.numDone,
                        numCanTotal: response.data.numTotal === undefined ? null : response.data.numTotal,
                        dispensing: !response.data.finished
                    }
                }
            ];

            if (!response.data.meta.quickTint) {
                canisterActions.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_ADD_DISPENSED_PACKAGE,
                        params: {
                            colorStatsId: response.data.meta.colorStatsId
                        }
                    },
                    method: handlers.ADD_DISPENSED_PACKAGE,
                    tabId: 0
                });
            }

            if (
                state.settings.automaticPrint &&
                state.settings.printBeforeDispensing &&
                state.login.loggedUser.canEdit(resources.FUNCTION_PRINT) &&
                state.settings.printTasksBeforeDispensing.length > 0
            ) {
                let printPreviewActions = [];
                let tempPrintData = null;

                if (
                    state.rcc.dispensingFormula !== null &&
                    state.rcc.dispensingFormula.printData !== null &&
                    state.rcc.dispensingFormula.formula !== null
                ) {
                    tempPrintData = {
                        ...state.rcc.dispensingFormula.formula.getPrintData(state.settings.formulaUnits),
                        ...state.rcc.dispensingFormula.printData
                    };
                }

                for (let printTask of state.settings.printTasksBeforeDispensing) {
                    if (printTask.isActive(response.data.meta.quickTint, tempPrintData)) {
                        if (response.data.meta.orderId === null) {
                            if (printTask.preview) {
                                printPreviewActions.unshift({
                                    type: actionTypes.PRINT_FORMULA_WHILE_DISPENSING,
                                    payload: {
                                        printTask: printTask,
                                        numCanDone:
                                            response.data.numDone === undefined ? null : response.data.numDone + 1
                                    }
                                });
                            } else {
                                canisterActions.push({
                                    type: actionTypes.PRINT_FORMULA_WHILE_DISPENSING,
                                    payload: {
                                        printTask: printTask,
                                        numCanDone:
                                            response.data.numDone === undefined ? null : response.data.numDone + 1
                                    }
                                });
                            }
                        } else {
                            if (printTask.preview) {
                                printPreviewActions.unshift({
                                    type: actionTypes.TO_DISPENSE_PRINT_ORDER_WHILE_DISPENSING,
                                    payload: {
                                        orderId: isNaN(response.data.meta.orderId) ? 0 : response.data.meta.orderId,
                                        printTask: printTask,
                                        numCanDone:
                                            response.data.numDone === undefined ? null : response.data.numDone + 1
                                    }
                                });
                            } else {
                                canisterActions.push({
                                    type: actionTypes.TO_DISPENSE_PRINT_ORDER_WHILE_DISPENSING,
                                    payload: {
                                        orderId: isNaN(response.data.meta.orderId) ? 0 : response.data.meta.orderId,
                                        printTask: printTask,
                                        numCanDone:
                                            response.data.numDone === undefined ? null : response.data.numDone + 1
                                    }
                                });
                            }
                        }
                    }
                }

                for (let previewAction of printPreviewActions) {
                    canisterActions.push(previewAction);
                }
            }

            return canisterActions;
        case methods.MACHINE_EVENT_DISPENSE_CANISTER_DONE:
        case methods.MACHINE_EVENT_DISPENSE_CANISTER_ERROR:
            if (!rccHelper.isDispenseCanisterDoneEventValid(response)) {
                return [messageHelper.getRccInvalidFormatMessage(response)];
            }

            let canisterDoneRequests = [];

            if (response.data.meta.quickTint) {
                if (state.rcc.dispensingFormula !== null) {
                    canisterDoneRequests.push({
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_ADD_QUICK_TINT_INTO_STATISTICS,
                            params: {
                                colorants: state.rcc.dispensingFormula.formula.getRealColorantAmounts(),
                                clientName: state.module.clientIdentifier,
                                priceList: state.rcc.dispensingFormula.priceList,
                                infoData: state.rcc.dispensingFormula.infoData,
                                printData: state.rcc.dispensingFormula.printData,
                                tmcData: state.rcc.dispensingFormula.tmcData,
                                moreInfo: state.rcc.dispensingFormula.dispenseNote,
                                moreInfoInternal: state.rcc.dispensingFormula.moreInfoInternal,
                                colorRgb: state.settings.generateColorPreview
                                    ? state.rcc.dispensingFormula.formula.color.rgb
                                    : null
                            }
                        },
                        method: handlers.ADD_QUICK_TINT_INTO_STATISTICS,
                        tabId: 0
                    });
                }
            } else {
                if (
                    state.login.loggedUser.canEdit(resources.FUNCTION_VALIDATE_ORDER_PACKAGE) &&
                    state.toDispense.dispensedOrder !== null &&
                    state.toDispense.dispensedOrder.note !== null &&
                    state.toDispense.dispensedOrder.note.length > 0
                ) {
                    canisterDoneRequests.push({
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_SET_ORDER_MORE_INFO,
                            params: {
                                orderIdentifier: state.toDispense.dispensedOrder.identifier,
                                moreInfo: state.toDispense.dispensedOrder.note
                            }
                        },
                        method: handlers.SET_ORDER_MORE_INFO,
                        tabId: 0
                    });
                }

                canisterDoneRequests.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_FINISH_DISPENSED_PACKAGE,
                        params: {
                            colorStatsId: response.data.meta.colorStatsId,
                            numCanDone: response.data.numDone === undefined ? null : response.data.numDone,
                            error: response.event === methods.MACHINE_EVENT_DISPENSE_CANISTER_ERROR
                        }
                    },
                    method: handlers.FINISH_DISPENSED_PACKAGE,
                    tabId: 0
                });
            }

            canisterDoneRequests.push({
                type: actionTypes.UPDATE_DISPENSING_INFO,
                payload: {
                    tabId: response.data.meta.tabId,
                    numCanDone: response.data.numDone === undefined ? null : response.data.numDone,
                    numCanTotal: response.data.numTotal === undefined ? null : response.data.numTotal,
                    dispensing: !response.data.finished
                }
            });

            canisterDoneRequests.push({
                type: actionTypes.RCC_REQUEST,
                payload: {
                    type: methods.METHOD_MACHINE_CANISTERS
                },
                method: handlers.MACHINE_CANISTERS,
                tabId: 0,
                safe: false
            });

            if (
                response.event === methods.MACHINE_EVENT_DISPENSE_CANISTER_DONE &&
                state.settings.automaticPrint &&
                state.settings.printAfterDispensing &&
                state.login.loggedUser.canEdit(resources.FUNCTION_PRINT) &&
                state.settings.printTasksAfterDispensing.length > 0
            ) {
                let printPreviewAfterActions = [];
                let tempPrintData = null;

                if (
                    state.rcc.dispensingFormula !== null &&
                    state.rcc.dispensingFormula.printData !== null &&
                    state.rcc.dispensingFormula.formula !== null
                ) {
                    tempPrintData = {
                        ...state.rcc.dispensingFormula.formula.getPrintData(state.settings.formulaUnits),
                        ...state.rcc.dispensingFormula.printData
                    };
                }

                for (let printTask of state.settings.printTasksAfterDispensing) {
                    if (printTask.isActive(response.data.meta.quickTint, tempPrintData)) {
                        if (response.data.meta.orderId === null) {
                            if (printTask.preview) {
                                printPreviewAfterActions.unshift({
                                    type: actionTypes.PRINT_FORMULA_WHILE_DISPENSING,
                                    payload: {
                                        printTask: printTask,
                                        numCanDone: response.data.numDone === undefined ? null : response.data.numDone
                                    }
                                });
                            } else {
                                canisterDoneRequests.push({
                                    type: actionTypes.PRINT_FORMULA_WHILE_DISPENSING,
                                    payload: {
                                        printTask: printTask,
                                        numCanDone: response.data.numDone === undefined ? null : response.data.numDone
                                    }
                                });
                            }
                        } else {
                            if (printTask.preview) {
                                printPreviewAfterActions.unshift({
                                    type: actionTypes.TO_DISPENSE_PRINT_ORDER_WHILE_DISPENSING,
                                    payload: {
                                        orderId: isNaN(response.data.meta.orderId) ? 0 : response.data.meta.orderId,
                                        printTask: printTask,
                                        numCanDone: response.data.numDone === undefined ? null : response.data.numDone
                                    }
                                });
                            } else {
                                canisterDoneRequests.push({
                                    type: actionTypes.TO_DISPENSE_PRINT_ORDER_WHILE_DISPENSING,
                                    payload: {
                                        orderId: isNaN(response.data.meta.orderId) ? 0 : response.data.meta.orderId,
                                        printTask: printTask,
                                        numCanDone: response.data.numDone === undefined ? null : response.data.numDone
                                    }
                                });
                            }
                        }
                    }
                }

                for (let previewAction of printPreviewAfterActions) {
                    canisterDoneRequests.push(previewAction);
                }
            }

            // Update dispensing history if the tab is open
            const statisticsTab = state.navigation.tabList.find((tab) => tab.type === componentTypes.STATISTICS_TAB);
            if (statisticsTab) {
                canisterDoneRequests.push({
                    type: actionTypes.STATISTICS_LIST_UPDATE,
                    payload: {
                        tabId: statisticsTab.id
                    }
                });
            }

            return canisterDoneRequests;
        case methods.MACHINE_EVENT_SENSORS_UPDATED:
            return [
                {
                    type: actionTypes.UPDATE_MACHINE_SENSOR,
                    payload: {
                        update: response.data
                    }
                }
            ];
        case methods.MACHINE_EVENT_LAST_ACTIONS_UPDATED:
            return [
                {
                    type: actionTypes.SAVE_MACHINE_HISTORY_ACTIONS,
                    payload: {
                        historyActions: response.data
                    }
                }
            ];
        case methods.MACHINE_EVENT_AUTOTASK_ADDED:
        case methods.MACHINE_EVENT_AUTOTASK_UPDATED:
        case methods.MACHINE_EVENT_AUTOTASK_DELETED:
            return [
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_AUTOTASKS
                    },
                    method: handlers.MACHINE_GET_AUTOTASKS,
                    tabId: 0,
                    safe: true
                }
            ];
        case methods.SPECTRO_EVENT_DIALOG_SHOW:
            return [
                {
                    type: actionTypes.SAVE_SPECTRO_DIALOG,
                    payload: {
                        dialog: modelHelper.createSpectroDialog(response.data)
                    }
                },
                {
                    type: actionTypes.OPEN_SPECTRO_DIALOG
                }
            ];
        case methods.SPECTRO_EVENT_DIALOG_HIDE:
            return [
                {
                    type: actionTypes.CANCEL_SPECTRO_DIALOG
                }
            ];
        case methods.SPECTRO_EVENT_PREVIEW_UPDATE:
            return [
                {
                    type: actionTypes.UPDATE_SPECTRO_PREVIEW,
                    payload: {
                        image: response.data.image
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_RCC_ACTION
                }
            ];
    }
};
